import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '客户公司',
    sort: 0
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'website',
    fieldName: '企业网站'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'phone',
    fieldName: '企业联系'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'email',
    fieldName: '企业邮箱'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'address',
    fieldName: '省市县'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'addressDetail',
    fieldName: '详细地址'
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'customerLevelId',
    fieldName: '客户级别',
    url: 'customerLevel/dropdown',
    selectType: 2,
    label: 'mark',
    option: []
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'customerSourceId',
    fieldName: '客户来源',
    url: 'customerSource/dropdown',
    selectType: 2,
    label: 'mark',
    option: []
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'paymentCycleId',
    fieldName: '客户付款周期',
    url: 'paymentCycle/dropdown',
    selectType: 2,
    label: 'mark',
    option: []
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'industryId',
    fieldName: '所属行业',
    url: 'industry/dropdown',
    selectType: 2,
    label: 'mark',
    option: []
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'companyTypeId',
    fieldName: '公司类型',
    url: 'companyType/dropdown',
    selectType: 2,
    label: 'mark',
    option: []
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'overdueDaysWithoutBusiness',
    fieldName: '超期未合作'
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'overdueWithoutBusinessNoticeSwitch',
    fieldName: '超期未合作提醒',
    url: 'WhetherType',
    selectType: 1,
    option: []
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'overdueDaysWithoutOrder',
    fieldName: '超期未订单天数'
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'overdueWithoutOrderNoticeSwitch',
    fieldName: '超期未订单提醒',
    url: 'WhetherType',
    selectType: 1,
    option: []
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'overdueDaysWithoutContact',
    fieldName: '超期未联系天数'
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'overdueWithoutContactNoticeSwitch',
    fieldName: '超期未联系提醒',
    url: 'WhetherType',
    selectType: 1,
    option: []
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'overdueDaysWithoutPayment',
    fieldName: '超期未收款天数'
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'overdueWithoutPaymentNoticeSwitch',
    fieldName: '超期未收款提醒',
    url: 'WhetherType',
    selectType: 1,
    option: []
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'salesMan',
    fieldName: '业务员'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'mark',
    fieldName: '备注'
  }, {
    componentType: 'el-select',
    componentName: '下拉选择',
    fieldKey: 'status',
    fieldName: '审批状态',
    url: 'ReviewStatus',
    selectType: 1,
    option: []
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createUser',
    fieldName: '创建人'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'updateUser',
    fieldName: '修改人'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createTime',
    fieldName: '创建时间'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'updateTime',
    fieldName: '申请时间',
    width: 160
  }
]
